import { render, staticRenderFns } from "./SharedNavigation.vue?vue&type=template&id=060b7c4d"
import script from "./SharedNavigation.vue?vue&type=script&lang=js"
export * from "./SharedNavigation.vue?vue&type=script&lang=js"
import style0 from "./SharedNavigation.vue?vue&type=style&index=0&id=060b7c4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports